const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFBene3Cp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uuid-508857a4-62d8-419c-98f3-bbab5c62613f",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M45.35,85.7c-22.25,0-40.35-18.1-40.35-40.35S23.1,5,45.35,5s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35ZM45.35,9.76c-19.62,0-35.59,15.97-35.59,35.59s15.97,35.59,35.59,35.59,35.59-15.97,35.59-35.59S64.97,9.76,45.35,9.76Z",
    style: {
      fill: "#4a46ab"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "uuid-56d178a9-cad1-4e0f-a453-23995e3e0342"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.01,56.46c0-2.45,1.99-4.44,4.44-4.44h8.89v-20c0-3.68-2.99-6.67-6.67-6.67h-26.67c-3.68,0-6.67,2.99-6.67,6.67v26.67c0,3.68,2.99,6.67,6.67,6.67h20v-8.89ZM52.01,38.68c1.23,0,2.22.99,2.22,2.22s-.99,2.22-2.22,2.22-2.22-1-2.22-2.22.99-2.22,2.22-2.22ZM38.68,38.68c1.23,0,2.22.99,2.22,2.22s-.99,2.22-2.22,2.22-2.22-1-2.22-2.22.99-2.22,2.22-2.22ZM36.9,46.24c.74-.98,2.13-1.18,3.11-.44.88.66,2.75,1.78,5.33,1.78,1.11,0,3.27-.23,5.33-1.78.98-.74,2.37-.54,3.11.44.74.98.54,2.37-.44,3.11-3.09,2.32-6.34,2.67-8,2.67-3.87,0-6.68-1.67-8-2.67-.98-.74-1.18-2.13-.44-3.11Z",
    style: {
      fill: "#4a46ab"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.46 64.05 64.05 56.46 56.46 56.46 56.46 64.05",
    style: {
      fill: "#4a46ab"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFBene3Cp);
export default __webpack_public_path__ + "static/media/F-Bene3-CP.afe58c34050b3a604f2ee412fb878b56.svg";
export { ForwardRef as ReactComponent };